import { Attribute, AttributeProperty } from "react-builder";

export class CarouselSettingsAttributes extends Attribute {
  @AttributeProperty({ type: "Boolean" })
  autoPlay: boolean = false;
  @AttributeProperty({ type: "Number" })
  autoPlayInterval = 5000;
  @AttributeProperty({ type: "Boolean" })
  sliderSnap: boolean = true;
}
